<template>
    <div>
        <intro :product="key"></intro>
        <section v-if="key === 'junta_culata' || key === 'tornillos' || key === 'retenes' || key === 'tubos_engrase' || key === 'tubos_egr' || key === 'junta_turbo' || key === 'taques' || key === 'arbol_levas' || key === 'otros'" class="product-details section-links flex wrap">
            <article class="col-50 pad-sec">
                <div class="container-text">
                    <h2 class="title title-26" v-html="$t(`productos.${key}.details.tips['tip-1']['title']`)"></h2>
                    <p v-html="$t(`productos.${key}.details.tips['tip-1']['content']`)"></p>
                </div>
            </article>
            <article class="col-50 pad-sec" v-if="$t(`productos.${key}.details.tips['tip-2']`) !== 'none'">
                <div class="container-text">
                    <h2 class="title title-26" v-html="$t(`productos.${key}.details.tips['tip-2']['title']`)"></h2>
                    <p v-html="$t(`productos.${key}.details.tips['tip-2']['content']`)"></p>
                </div>
            </article>
        </section>
        <section class="dropdown-product-details-container">
            <dropdown v-for="(dropdown, key) in $t(`productos.${key}.details.dropdowns`)" :key="key" :title="dropdown.title"
                :contentPanel="dropdown.content"></dropdown>
            <div class="sec-center">
                <a class="btn btn-dark -yellow-full" target="_blank"
                    :href="'mailto:'+$t(`contacto.email`)">
                    {{ $t(`productos.${key}.details.btn_more_info.text`) }}
                </a>
            </div>
        </section>
        <videos :intro="false" id="videos"></videos>
    </div>
</template>

<script lang="js">
import Intro from '@/components/view-parts/intros/product';
import Dropdown from '@/components/view-parts/dropdown';
import Videos from '@/components/view-parts/actualidad-parts/videos';

export default {
    name: 'product-details',
    components: {
        'intro': Intro,
        'dropdown': Dropdown,
        'videos': Videos,
    },
    data() {
        const id = this.$route.params.id.replace('ç', 'c')
        const key = this.$t(`productos.keys.${id}`);
        return {
            key
        }
    },
    created() {
        if(!this.$route.params.id){
            this.$router.push('productos');
        }
    },
    mounted() {
        document.title = this.$t(`enlaces.seo.${this.key}.title`);
        document.head.querySelector("[name='description']").content = this.$t(`enlaces.seo.${this.key}.description`);
        document.head.querySelector("[property='og:title']").content = this.$t(`enlaces.seo.${this.key}.title`);
        document.head.querySelector("[property='og:description']").content = this.$t(`enlaces.seo.${this.key}.description`);
        document.head.querySelector("[property='og:url']").content = location.href;
        document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.${this.key}.keyword`);
    },
    watch: {
      "$route.params.id"(){
        if (this.$route.params.id) {
            const id = this.$route.params.id.replace('ç', 'c');
            this.key = this.$t(`productos.keys.${id}`);
            document.title = this.$t(`enlaces.seo.${this.key}.title`);
            document.head.querySelector("[name='description']").content = this.$t(`enlaces.seo.${this.key}.description`);
            document.head.querySelector("[property='og:title']").content = this.$t(`enlaces.seo.${this.key}.title`);
            document.head.querySelector("[property='og:description']").content = this.$t(`enlaces.seo.${this.key}.description`);
            document.head.querySelector("[property='og:url']").content = location.href;
            document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.${this.key}.keyword`);
        }
      }
    },
}
</script>

<style>
.product-details.section-links .pad-sec {
    padding: 60px 0 !important;
    flex-grow: 1;
}

.product-details.section-links .container-text {
    max-width: none !important;
}

.product-details.section-links article:first-of-type {
    background: rgb(5, 66, 121) !important;
    color: white !important;
}

.product-details.section-links .container-text .title-26{
    margin-bottom: 20px !important;
}

#videos {
    background-color: #cdd9e5 !important;
    padding-top: 0 !important;
}

@media screen and (max-width:930px) {
    .product-details.section-links {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .product-details.section-links article {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/product-details.vue